import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {
    ActionCardImage,
    GraphicalActionCard,
    LinkWithAttribution,
} from '../../../../../../components';

export function OsteopeniaExercise(props) {
    const {currentStep, totalSteps} = props;

    const intl = useIntl();

    return (
        <GraphicalActionCard
            currentStep={currentStep}
            dataTestId={'exercise-FNDXAT_N1P0'}
            headerImage={ActionCardImage.EXERCISE}
            title={intl.formatMessage({id: 'reports.trait.lifestyleActions.exercise.title'})}
            totalSteps={totalSteps}
        >
            <p>
                <FormattedMessage
                    id={'reports.trait.lifestyleActions.exercise.description.one.FNDXAT_N1P0'}
                />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.two'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.three'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.description.four'} />
            </p>
            <ul>
                <li>
                    <FormattedMessage id={'reports.trait.lifestyleActions.exercise.item.one'} />
                </li>
                <li>
                    <FormattedMessage id={'reports.trait.lifestyleActions.exercise.item.two'} />
                </li>
                <li>
                    <FormattedMessage id={'reports.trait.lifestyleActions.exercise.item.three'} />
                </li>
            </ul>
            <p>
                <FormattedMessage
                    id={'reports.trait.lifestyleActions.exercise.description.two.FNDXAT_N1P0'}
                />
            </p>
            <ul>
                <li>
                    <FormattedMessage
                        id={'reports.trait.lifestyleActions.exercise.item.FNDXAT_N1P0.one'}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id={'reports.trait.lifestyleActions.exercise.item.FNDXAT_N1P0.two'}
                    />
                </li>
            </ul>
            <p>
                <FormattedMessage
                    id={'reports.trait.lifestyleActions.exercise.description.three.FNDXAT_N1P0'}
                />
            </p>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.CDCP'})}
                url={'https://www.cdc.gov/healthyweight/physical_activity/getting_started.html'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.link.start'} />
            </LinkWithAttribution>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.BHOF'})}
                url={'https://www.bonehealthandosteoporosis.org/preventing-fractures/exercise-to-stay-healthy/'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.exercise.link.healthy'} />
            </LinkWithAttribution>
        </GraphicalActionCard>
    );
}
